import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/containers/simple-layout/simple-layout.component.ts